export const comics = [
  {
    id: 1,
    title: '霸道总裁的契约新娘',
    author: '金秀贤',
    category: 'romance',
    categoryName: '恋爱',
    rating: 9.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20elegant%20couple%20in%20modern%20setting%2C%20soft%20warm%20lighting%2C%20beautiful%20illustration%20style%20with%20delicate%20linework%2C%20simple%20cream%20background%20with%20subtle%20floral%20elements%2C%20professional%20manhwa%20cover%20aesthetic&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    chapters: 128,
    updateDate: '2026-07-02',
    description: '平凡女孩意外与霸道总裁签订契约婚姻，两人从互相嫌弃到逐渐心动。然而总裁的前女友突然回归，一场关于爱情与信任的考验就此展开……',
    featured: true,
  },
  {
    id: 2,
    title: '重生之豪门千金',
    author: '李智恩',
    category: 'romance',
    categoryName: '恋爱',
    rating: 9.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%2C%20elegant%20woman%20in%20luxurious%20setting%2C%20rebirth%20theme%2C%20dramatic%20composition%2C%20warm%20golden%20lighting%2C%20refined%20illustration%20style%2C%20clean%20cream%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    chapters: 96,
    updateDate: '2026-07-01',
    description: '被害死后重生回到十年前，她发誓要让所有伤害过她的人付出代价。凭借着前世的记忆，她一步步布局，却没想到复仇路上遇到了真爱……',
    featured: true,
  },
  {
    id: 3,
    title: '剑与魔法的传说',
    author: '朴正宇',
    category: 'fantasy',
    categoryName: '奇幻',
    rating: 9.7,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%2C%20epic%20warrior%20with%20sword%20in%20magical%20world%2C%20dramatic%20action%20pose%2C%20warm%20atmospheric%20lighting%2C%20detailed%20fantasy%20illustration%2C%20simple%20cream%20background&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    chapters: 156,
    updateDate: '2026-07-03',
    description: '在剑与魔法并存的大陆上，少年剑士踏上寻找传说之剑的旅途。一路上结识了精灵、矮人和龙族伙伴，共同对抗黑暗势力的入侵。',
    featured: true,
  },
  {
    id: 4,
    title: '秘密花园',
    author: '崔美英',
    category: 'drama',
    categoryName: '剧情',
    rating: 9.4,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%2C%20mysterious%20garden%20scene%2C%20emotional%20character%20portrait%2C%20soft%20diffused%20lighting%2C%20delicate%20watercolor%20illustration%20style%2C%20clean%20cream%20background&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    chapters: 72,
    updateDate: '2026-06-30',
    description: '失去记忆的少女在一座神秘花园中醒来，花园里的每一朵花都承载着一段被遗忘的记忆。她必须找回所有的记忆碎片，才能揭开自己的真实身份。',
    featured: false,
  },
  {
    id: 5,
    title: '暗夜追踪者',
    author: '金泰亨',
    category: 'action',
    categoryName: '动作',
    rating: 9.2,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%2C%20noir%20detective%20in%20dark%20alley%2C%20intense%20atmosphere%2C%20sharp%20contrast%20illustration%2C%20dramatic%20composition%2C%20simple%20cream%20background&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    chapters: 88,
    updateDate: '2026-07-02',
    description: '前特种兵成为私家侦探，接手一桩看似普通的失踪案后，却被卷入一场涉及政商黑幕的巨大阴谋。每一步都危机四伏，每一个真相都令人震惊。',
    featured: false,
  },
  {
    id: 6,
    title: '校园恋爱手册',
    author: '郑秀晶',
    category: 'romance',
    categoryName: '恋爱',
    rating: 9.1,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20school%20cover%2C%20cheerful%20students%20in%20school%20uniform%2C%20bright%20spring%20atmosphere%2C%20heartwarming%20illustration%20style%2C%20soft%20pastel%20tones%2C%20clean%20cream%20background&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    chapters: 64,
    updateDate: '2026-07-01',
    description: '高冷学霸与活泼少女的校园恋爱故事。从互相看不顺眼到渐渐被对方吸引，青涩甜蜜的校园日常让人忍不住嘴角上扬。',
    featured: false,
  },
  {
    id: 7,
    title: '异世界食堂',
    author: '姜东元',
    category: 'fantasy',
    categoryName: '奇幻',
    rating: 9.6,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20food%20cover%2C%20cozy%20restaurant%20in%20magical%20world%2C%20warm%20inviting%20atmosphere%2C%20detailed%20food%20and%20character%20illustration%2C%20simple%20cream%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    chapters: 112,
    updateDate: '2026-07-03',
    description: '一间连通两个世界的餐厅，老板用美食治愈来自异世界的客人们。精灵、兽人、魔王都成了常客，而最大的秘密是——老板本人也来自异世界。',
    featured: true,
  },
  {
    id: 8,
    title: '推理之夜',
    author: '尹恩惠',
    category: 'suspense',
    categoryName: '悬疑',
    rating: 9.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20cover%2C%20detective%20examining%20clues%20in%20dim%20room%2C%20suspenseful%20atmosphere%2C%20sharp%20detailed%20illustration%20style%2C%20simple%20cream%20background&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    chapters: 80,
    updateDate: '2026-06-29',
    description: '天才犯罪心理学家与刑警搭档，破解一桩桩看似毫无关联却暗中相连的连环案件。每解开一个谜题，都离最终的真相更近一步。',
    featured: false,
  },
  {
    id: 9,
    title: '花美男乐团',
    author: '宋慧乔',
    category: 'romance',
    categoryName: '恋爱',
    rating: 9.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20music%20band%20cover%2C%20handsome%20musicians%20on%20stage%2C%20energetic%20concert%20atmosphere%2C%20stylish%20illustration%2C%20vibrant%20yet%20warm%20tones%2C%20clean%20cream%20background&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    chapters: 56,
    updateDate: '2026-06-28',
    description: '普通女高中生意外成为人气乐团的临时经纪人，与五位花美男成员朝夕相处。音乐、梦想与爱情交织的青春故事就此展开。',
    featured: false,
  },
  {
    id: 10,
    title: '末日生存指南',
    author: '权志龙',
    category: 'action',
    categoryName: '动作',
    rating: 9.8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20post%20apocalyptic%20cover%2C%20survivor%20in%20ruined%20city%2C%20intense%20survival%20atmosphere%2C%20gritty%20detailed%20illustration%20style%2C%20dramatic%20composition%2C%20simple%20cream%20background&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    chapters: 140,
    updateDate: '2026-07-03',
    description: '不明病毒席卷全球，文明社会瞬间崩塌。退役士兵李明浩带领幸存者们在废墟中建立新的家园，但比丧尸更可怕的，是人性深处的黑暗。',
    featured: true,
  },
  {
    id: 11,
    title: '我的邻居是吸血鬼',
    author: '沈恩京',
    category: 'fantasy',
    categoryName: '奇幻',
    rating: 9.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20vampire%20romance%20cover%2C%20mysterious%20vampire%20couple%20in%20moonlight%2C%20gothic%20romantic%20atmosphere%2C%20elegant%20illustration%20style%2C%20dark%20warm%20tones%2C%20clean%20cream%20background&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    chapters: 68,
    updateDate: '2026-06-27',
    description: '搬进新公寓后发现邻居是一位活了三百年的吸血鬼。本以为会很危险，没想到这位吸血鬼先生不仅绅士，还帮她解决了生活中的各种麻烦。',
    featured: false,
  },
  {
    id: 12,
    title: '棋魂：新时代',
    author: '李世石',
    category: 'drama',
    categoryName: '剧情',
    rating: 9.6,
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20go%20game%20cover%2C%20young%20player%20focused%20on%20board%2C%20intense%20concentration%2C%20elegant%20minimal%20illustration%2C%20clean%20composition%2C%20simple%20cream%20background&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    chapters: 104,
    updateDate: '2026-07-01',
    description: '天才围棋少年在AI时代重新定义围棋之美。与世界各地的高手对弈，在黑白之间探寻人生哲理，一场关于传承与创新的围棋之旅。',
    featured: false,
  },
];

export const categories = [
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line', count: 320 },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', count: 215 },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', count: 198 },
  { slug: 'drama', name: '剧情', icon: 'ri-emotion-line', count: 176 },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line', count: 142 },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-happy-line', count: 165 },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line', count: 88 },
  { slug: 'slice-of-life', name: '日常', icon: 'ri-home-heart-line', count: 134 },
];

export const reviews = [
  {
    id: 1,
    name: '漫画迷小王',
    avatar: '王',
    rating: 5,
    content: '韩漫屋真的是我见过最好的韩漫平台！画质清晰，更新超快，而且完全免费。每天必刷，已经成了我的精神食粮了。推荐给了好多朋友，大家都说好！',
  },
  {
    id: 2,
    name: '追漫达人Lily',
    avatar: 'L',
    rating: 5,
    content: '作为一个看了十年韩漫的老读者，韩漫屋的漫画资源真的太全了。很多小众好漫画在这里都能找到，分类也很清晰，找漫画特别方便。强烈推荐！',
  },
  {
    id: 3,
    name: '夜猫子读者',
    avatar: '夜',
    rating: 4,
    content: '界面简洁好看，没有任何乱七八糟的广告，阅读体验很棒。唯一的建议就是希望夜间模式能再优化一下，晚上看漫画对眼睛更友好。',
  },
  {
    id: 4,
    name: '二次元少女',
    avatar: '二',
    rating: 5,
    content: '从朋友那里知道的韩漫屋，一试就爱上了！漫画更新速度真的很快，而且翻译质量也很高。现在每天中午休息时间都要刷几话，完全停不下来~',
  },
];

export const editorPicks = [
  {
    id: 1,
    title: '末日生存指南',
    rating: 9.8,
    comment: '年度最佳动作漫画，末日题材的巅峰之作。画面张力十足，剧情紧凑到让人无法放下。每一话都像看一部好莱坞大片，强烈推荐给所有喜欢刺激的读者。',
    editor: '主编 - 韩漫君',
  },
  {
    id: 2,
    title: '异世界食堂',
    rating: 9.6,
    comment: '温暖治愈的美食奇幻漫画。用美食连接两个世界，每个故事都让人心头一暖。画风精美，食物描绘得让人垂涎欲滴，是下班后放松心情的最佳选择。',
    editor: '编辑 - 小漫',
  },
  {
    id: 3,
    title: '棋魂：新时代',
    rating: 9.6,
    comment: '将传统围棋与现代AI完美融合的佳作。不止是关于围棋，更是关于成长与坚持的故事。每一局棋都像一场心理战，让人看得热血沸腾又思考良多。',
    editor: '编辑 - 棋子',
  },
];

export const featuredArticles = [
  {
    id: 1,
    title: '2026年必看韩漫TOP10推荐',
    category: '推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20collection%2C%20various%20characters%20collage%2C%20colorful%20artistic%20illustration%2C%20vibrant%20energetic%20style%2C%20simple%20cream%20background&width=600&height=400&seq=article-cover-01&orientation=landscape',
    date: '2026-06-25',
    excerpt: '今年有哪些韩漫值得追？我们为你精选了十部口碑爆棚的作品，从恋爱到奇幻，总有一部适合你。',
  },
  {
    id: 2,
    title: '韩漫入门指南：新手必读的5部经典',
    category: '指南',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20reading%20guide%2C%20stack%20of%20colorful%20comics%2C%20cozy%20reading%20atmosphere%2C%20warm%20lighting%2C%20clean%20illustration%20style%2C%20simple%20cream%20background&width=600&height=400&seq=article-cover-02&orientation=landscape',
    date: '2026-06-20',
    excerpt: '刚接触韩漫不知道从哪开始？这份入门指南帮你快速找到最适合的韩漫作品，轻松融入韩漫世界。',
  },
  {
    id: 3,
    title: '韩漫与日漫的区别：风格与叙事对比',
    category: '分析',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20versus%20Japanese%20comics%20comparison%2C%20split%20composition%2C%20artistic%20contrast%2C%20clean%20modern%20design%2C%20simple%20cream%20background&width=600&height=400&seq=article-cover-03&orientation=landscape',
    date: '2026-06-15',
    excerpt: '韩漫和日漫有什么不同？从画风、叙事节奏到阅读方式，全面解析两者的独特魅力。',
  },
];